import { Query } from '@/app/tracking/api';

export interface QueryInteractionStatesTrackingQueryPayload {
}

export interface QueryInteractionStatesTrackingQueryResult {
  interactionStates: InteractionState[]
}

export interface InteractionState {
  id: string
  type: string,
  state: unknown
}

export const QueryInteractionStatesTrackingQueryName = 'query-interaction-states' as const
export type QueryInteractionStatesTrackingQuery =
      Query<typeof QueryInteractionStatesTrackingQueryName, QueryInteractionStatesTrackingQueryPayload, QueryInteractionStatesTrackingQueryResult>
